import { render, staticRenderFns } from "./aufgabe_offen.vue?vue&type=template&id=6e6e3a9a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./aufgabe_offen.vue?vue&type=script&lang=js"
export * from "./aufgabe_offen.vue?vue&type=script&lang=js"
import style0 from "./aufgabe_offen.vue?vue&type=style&index=0&id=6e6e3a9a&prod&lang=css"
import style1 from "./aufgabe_offen.vue?vue&type=style&index=1&id=6e6e3a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e3a9a",
  null
  
)

export default component.exports